import React, { useState } from "react";
import Swal from "sweetalert2";
import { Badge, Table } from "react-bootstrap";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import DialogLayout from "../../../../partials/content/DialogLayout";
import ItemsRequestForm from "../../inventory/stock-management/items-reservation/itemsRequestForm";
import { formatDate } from "../../../../utils/utils";
import { Typography } from "@material-ui/core";
import Illustration from "../../../../partials/content/Illustration";
import { cancelItemRequest } from "../../../../services/inventory/itemReservationService";
function SalesReturnItemsRequest({
  salesReturnID = 0,
  itemsRequestImp = [],
  onReloadData,
}) {
  const [itemsRequest, setItemsRequest] = useState(itemsRequestImp);
  const [openItemsRequestForm, setOpenItemsRequestForm] = useState(false);
  return (
    <React.Fragment>
      <Table striped borderless size="sm" responsive="xl">
        {itemsRequest && itemsRequest.length > 0 ? (
          <thead>
            <tr>
              <th>Item Request ID</th>
              <th>Warehouse</th>
              <th>Request Date</th>
              <th>Item Name</th>
              <th>Qty</th>
              <th>Unit</th>
              <th>Status</th>
              <th>
                <BootstrapTooltip title="Delete Items Request">
                  <button
                    type="button"
                    onClick={() => {
                      setOpenItemsRequestForm(true);
                    }}
                    className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                  >
                    <i className="fas fa-plus-circle"></i>
                  </button>
                </BootstrapTooltip>
              </th>
            </tr>
          </thead>
        ) : null}
        <tbody>
          {itemsRequest && itemsRequest.length > 0 ? (
            itemsRequest.map((item, index) => (
              <tr key={index} className="border-top">
                <td>{item.ID}</td>
                <td>{item.warehouse.warehouseName}</td>
                <td>{formatDate(item.CreatedAt)}</td>
                <td>
                  <Typography className="mx-1 my-1">
                    {item.itemType > 0 ? (
                      <span>
                        <BootstrapTooltip title={item.itemTypeName}>
                          <span className="mr-2">
                            <i
                              className={
                                item.itemType === 1
                                  ? "fas fa-boxes text-success"
                                  : item.itemType === 2
                                  ? "fas fa-tools text-primary"
                                  : item.itemType === 3
                                  ? "fas fa-building text-info"
                                  : item.itemType === 4
                                  ? "fas fa-boxes text-warning"
                                  : item.itemType === 5
                                  ? "fas fa-boxes text-danger"
                                  : null
                              }
                            ></i>
                          </span>
                        </BootstrapTooltip>
                        <span>
                          {item.itemCode} {item.itemName}
                        </span>
                      </span>
                    ) : (
                      <React.Fragment>
                        {item.itemCode} {item.itemName}
                      </React.Fragment>
                    )}
                  </Typography>
                </td>
                <td>
                  <Typography className="mx-1 my-1">{item.qty}</Typography>
                </td>
                <td>
                  <Typography className="mx-1 my-1">
                    {item.uom.uomName}
                  </Typography>
                </td>
                <td>
                  {item.reserveStatusID === 1 ? (
                    <Badge variant="danger">{item.reserveStatusName}</Badge>
                  ) : item.reserveStatusID === 2 ? (
                    <Badge variant="warning">{item.reserveStatusName}</Badge>
                  ) : item.reserveStatusID === 3 ? (
                    <Badge variant="success">{item.reserveStatusName}</Badge>
                  ) : (
                    <Badge variant="dark">{item.reserveStatusName}</Badge>
                  )}
                </td>
                <td>
                  {item.statusID === 1 ? (
                    <BootstrapTooltip title="Delete Items Request">
                      <button
                        type="button"
                        onClick={() => {
                          cancelRequest(item);
                        }}
                        className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    </BootstrapTooltip>
                  ) : null}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td className="text-center py-3" colSpan="6">
                <Illustration
                  imageSource="INVIFO Procurement.png"
                  guidance="No Items Request found"
                  guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                  size="sm"
                ></Illustration>
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <DialogLayout
        open={openItemsRequestForm}
        title="Items Request Form"
        onCloseDialog={() => {
          setOpenItemsRequestForm(false);
        }}
      >
        <ItemsRequestForm
          salesReturnID={salesReturnID}
          onCloseDialog={() => {
            setOpenItemsRequestForm(false);
          }}
          onConfirmSave={() => {
            setOpenItemsRequestForm(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function cancelRequest(rowData) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Items Request ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          cancelItemRequest(rowData.ID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            onReloadData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }
}

export default SalesReturnItemsRequest;
